import {Button, Form, Upload, Input, Modal, Alert, notification, Select} from "antd";
import {
    MobileOutlined,
    PhoneOutlined,
    DashboardOutlined,
    PictureOutlined,
    IdcardOutlined,
    HomeOutlined, MailOutlined, UserOutlined
} from "@ant-design/icons";
import Request from "../../utilis/api/Request";
import React, {useContext, useEffect, useState} from "react";
import AuthContext from "../../utilis/contexts/AuthContext";
import {
    SaleTankerWaterValidation,
    Validation,
    WasteWaterBranchAssignmentValidation
} from "../../utilis/tools/validation";
import Urls from "../../utilis/api/Urls";
import Texts from "../../utilis/defaults/Text";
import {RcFile, UploadFile, UploadProps} from "antd/es/upload/interface";
import {getBase64, getMergeImage} from "../../utilis/helpers/imageHelper";
import AuthenticatedForm from "./AuthenticatedForm";
import {useOutletContext} from "react-router-dom";
import DefaultForm from "./DefaultForm";
import {ConvertPersianToEnglish} from "../../utilis/helpers/convertor";
import ServiceResponseTime from "../../utilis/enums/ServiceResponseTime";
import ResponseMessageHandler from "../../utilis/helpers/ResponseMessage";
import Text from "../../utilis/defaults/Text";
import AbfaLogo from "../../images/logo.png"
import AppContext from "../../utilis/contexts/AppContext";
import ValueLabel from "../../utilis/models/valueLabel";
import LocalStorage from "../../utilis/tools/LocalStorage";
import Api from "../../utilis/api/service";
import {AxiosError, AxiosResponse} from "axios";
import ConfirmInfoModal from "../modals/ConfirmInfoModal";

const SaleTankerWater = () => {
    const authContext = useContext(AuthContext);
    const appContext = useContext(AppContext);
    const {Option} = Select;
    // @ts-ignore
    const token = authContext.authenticated ? null : authContext.data.token;
    // @ts-ignore
    const {cities} = appContext.globalData;
    // @ts-ignore
    const [data, setData] = useState(authContext.authenticated ? authContext.data : authContext.data.data)
    const [isLoading, setLoading] = useState(false);
    const {TextArea} = Input;
    const [constructionLicenseList, setConstructionLicenseList] = useState<UploadFile[]>([]);

    const [previewOpen, setPreviewOpen] = useState(false);
    const [selectedCity, setSelectedCity] = useState(-1)
    const [constructionLicenseBase64, setConstructionLicenseBase64] = useState('');

    //merge-image
    useEffect(() => {
        getMergeImage(constructionLicenseList, (base64) => {

            setConstructionLicenseBase64(base64)
        })
    }, [constructionLicenseList]);

    const [previewImage, setPreviewImage] = useState('');

    const constructionLicenseProps: UploadProps = {
        fileList: constructionLicenseList,
        onRemove: file => {
            const index = constructionLicenseList.indexOf(file);
            const newFileList = constructionLicenseList.slice();
            newFileList.splice(index, 1);
            setConstructionLicenseList([]);
        },
        beforeUpload: (file: RcFile) => {

            if (file.size / 1000000 > 1) {
                notification['error']({
                    message: 'خطا',
                    description: 'فایل انتخابی باید کمتر از ۱ مگابایت باشد.',
                    duration: 120,
                })

            } else {
                getBase64(file).then((base64) => {
                    let newFile: UploadFile = file
                    newFile.thumbUrl = base64;
                    console.log(newFile)

                    setConstructionLicenseList([newFile]);
                    return false
                })


            }


            return false;
        },
    };

    const onPreview = async (file: UploadFile) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file as RcFile);
        }

        setPreviewImage(file.url || (file.preview as string));
        setPreviewOpen(true);
    };
    const handleCancel = () => setPreviewOpen(false);
    const handlePrint = (text: string, name: string, traceNumber: string, address: string, orderType: string, mobile: string) => {
        // @ts-ignore

        // @ts-ignore
        var newWin = window.open('', '', 'height=650, width=650');
        // @ts-ignore
        newWin.document.write('');
        // @ts-ignore

        // @ts-ignore
        newWin.document.write(`
            <div style="margin-bottom: 4px;display: flex; justify-content: center;font-family:'iranSans';"><h3>اداره آب و فاضلاب مازندران</h3></div>
            <div style="border: 1px solid #5e5d5d;border-radius: 7px">
                        <p style="padding: 10px;text-align: right;direction:rtl;border-radius: 4px;font-family:'iranSans'; ">${text}
        </p>
     
                <div style="direction:rtl;display: flex;justify-content: start;flex-wrap: wrap;font-family:'iranSans';">
                 <span style="padding: 10px;text-align: right;direction:rtl;border-radius: 4px;font-family:'iranSans'; ">نام و نام خانوادگی : ${name}</span>
                 <span style="padding: 10px;text-align: right;direction:rtl;border-radius: 4px;font-family:'iranSans'; ">کد رهگیری : ${traceNumber}</span>
                 <span style="padding: 10px;font-family:'iranSans';">نوع درخواست : ${orderType}</span>
                 <span style="padding: 10px;font-family:'iranSans';">موبایل : ${mobile}</span>
                 <span style="padding: 10px;font-family:'iranSans';">آدرس : ${address}</span>
        </div>
            </div>
                                   <div style="display: flex;justify-content: center;align-items: center;">
            <img style="width:250px;height: auto;margin-top: 50px; opacity: 80%" src="${AbfaLogo}" alt="">
</div>
        `);
        // @ts-ignore

        // @ts-ignore
        // @ts-ignore
        newWin.document.close();
        // @ts-ignore
        newWin.print();
    }
    const handleSubmit = (values: any) => {
        if(selectedCity==-1){
            notification['error']({
                message:'خطا',
                description: 'فیلد شهر الزامی می‌باشد.',
                duration: 120,
            });
        }
        const body = {
            "Token": token,
            "Cellphone": authContext.authenticated ? authContext.user.cellphone : data.cellphone,
            "NationalCode": authContext.authenticated ? ConvertPersianToEnglish(values.nationalCode) : data.national_code,
            "PostalCode": authContext.authenticated ? ConvertPersianToEnglish(values.postalCode) : data.postal_code,
            "TelNumber": ConvertPersianToEnglish(values.tel),
            "MobileNumber": ConvertPersianToEnglish(values.mobile),
            "FirstName": values.firstName,
            "LastName": values.lastName,
            "City": authContext.authenticated ? selectedCity : data.city,
            "Email": authContext.authenticated ? values.email : "",
            "Address": values.address ? values.address : data.address,
            "WaterVolume": ConvertPersianToEnglish(values.WaterVolume),

        };
        const cityName=cities.filter((city:any)=>city.value==selectedCity);

        const modalData = {
            ...body,
            CityName: cityName.length>0 ?   cityName[0].label : "",
        }
        Modal.confirm({
            direction: "rtl",
            title: 'آیا از صحت اطلاعات اطمینان دارید؟',
            content: <ConfirmInfoModal data={modalData} type={"SaleTankerWater"}/>,
            onOk: () => handleRequest(body, values),
            closable: true,
            centered: true,
            okText: "تایید و ارسال",
            cancelText: "بستن",
            width: 800,
        })



    }
    const handleRequest=(body:any,values:any)=>{
        setLoading(true)
        Request(Urls.SaleTankerWater, body).then((response: any) => {
            const key = `open${Date.now()}`;

            notification['success']({
                message: response.message,
                description: ResponseMessageHandler(ServiceResponseTime.SaleTankerWater, response.data.trace_number),
                duration: 120,
                key: key,
                btn: <Button type="primary" size="small" onClick={() => {
                    handlePrint(ResponseMessageHandler(ServiceResponseTime.SaleTankerWater, response.data.trace_number), data.first_name + " " + data.last_name, response.data.trace_number, body.Address, Text.SaleTankerWater, values.mobile);
                    notification.destroy()
                }}>
                    چاپ
                </Button>
            });
        }).catch(() => {

        }).finally(() => {
            setLoading(false)
        })
    }
    const handleCity = (value: number) => {
        const Token = LocalStorage.getToken();
        setSelectedCity(value);


    }

    const onFinishFailed = (error: any) => {

    }
    return <>
        <Form
            name="basic"
            className="w-full flex flex-col"
            layout='vertical'
            onFinish={handleSubmit}
            onFinishFailed={onFinishFailed}
            autoComplete="off" scrollToFirstError={true}
        >

            <div className="flex flex-col"><label htmlFor="">
                شهر
            </label>
                <Select showSearch filterOption={(input, option) => {

                    return (option?.children + "" ?? '').includes(input)
                }} size="large" onChange={handleCity} className="w-full">
                    {cities.map((city: ValueLabel) => <Option key={"city-" + city.value} value={city.value}>
                        {city.label}
                    </Option>)}
                </Select>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 mt-2  gap-3 ">
                <Form.Item
                    label="نام"
                    name="firstName"

                    rules={[Validation(SaleTankerWaterValidation)]}

                >
                    <Input size="large" placeholder="مثلا علی"
                           prefix={<UserOutlined className="text-gray-50"/>}/>
                </Form.Item>
                <Form.Item
                    label="نام خانوادگی"
                    name="lastName"
                    rules={[Validation(SaleTankerWaterValidation)]}
                >
                    <Input size="large" placeholder="مثلا حسینی"
                           prefix={<UserOutlined className="text-gray-50"/>}/>
                </Form.Item>
                <Form.Item
                    label="کد ملی"
                    name="nationalCode"
                    rules={[Validation(SaleTankerWaterValidation)]}

                >
                    <Input type="tel" size="large" placeholder="مثلا ۴۹۸۰۲۳۴۰۹۶"
                           prefix={<IdcardOutlined className="text-gray-50"/>}/>
                </Form.Item>
                <Form.Item
                    label="تلفن ثابت"
                    name="tel"

                    rules={[Validation(SaleTankerWaterValidation)]}
                >
                    <Input size="large" prefix={<PhoneOutlined className="text-gray-50"/>}
                           placeholder="مثلا ۰۱۱۳۵۷۵۵۳۴۳"/>
                </Form.Item>

                <Form.Item
                    label="تلفن همراه"
                    name="mobile"
                    initialValue={authContext.authenticated ? authContext.user.cellphone : ''}
                    rules={[Validation(SaleTankerWaterValidation)]}
                >
                    <Input size="large" placeholder="مثلا ۰۹۲۱۰۹۱۳۲۳۲"
                           prefix={<MobileOutlined className="text-gray-50"/>}/>
                </Form.Item>
                <Form.Item
                    label=" کد پستی محل مورد تقاضا"
                    name="postalCode"
                    rules={[Validation(SaleTankerWaterValidation)]}

                >
                    <Input type="tel" size="large" placeholder="مثلا ۴۹۸۰۲۳۴۴۴۱"
                           prefix={<HomeOutlined className="text-gray-50"/>}/>
                </Form.Item>
                <Form.Item rules={[Validation(SaleTankerWaterValidation)]} name="WaterVolume" label={"حجم آب (متر مکعب)"}>
                    <Input size="large" placeholder="مثلا ۳۰۰۰"
                           prefix={<DashboardOutlined/>}/>
                </Form.Item>
                <Form.Item
                    label="ایمیل"
                    name="email"
                    requiredMark="optional"

                    rules={[Validation(SaleTankerWaterValidation)]}
                >
                    <Input size="large" placeholder="example@gmail.com"
                           prefix={<MailOutlined className="text-gray-50"/>}/>
                </Form.Item>


            </div>
            <Form.Item
                label="آدرس محل مورد تقاضا"
                name="address"
                rules={[Validation(SaleTankerWaterValidation)]}
            >
                <TextArea placeholder="..."/>
            </Form.Item>
            {/* <AuthenticatedForm validationSchema={SaleTankerWaterValidation} data={data}/>
            <DefaultForm validationSchema={SaleTankerWaterValidation} data={data}/>*/}



            {/*    <div className="mt-2 mb-2">
                <Alert className="mb-2 mt-2"
                       message="  کلیه تصاویر ارسالی باید در یکی از فرمت های jpg،tif،tiff،jpeg باشد." type="error"/>
            </div>
            <Form.Item requiredMark="optional"
                       label={Texts.documentsImage}
                       name="constructionLicense"
            >
                <Upload  accept={"image/jpg,image/tif,image/tiff,image/png, image/jpeg"} onPreview={onPreview}
                        listType="picture-card" maxCount={1}  {...constructionLicenseProps}>
                    <PictureOutlined/>
                </Upload>
            </Form.Item>*/}


            <Form.Item className="w-full mt-4">
                <Button loading={isLoading} size="large" type="primary" className="bg-primary w-full  md:w-[150px]"
                        htmlType="submit">
                    ثبت درخواست
                </Button>
            </Form.Item>

        </Form>
        <Modal open={previewOpen} title="تصویر" footer={null} onCancel={handleCancel}>
            <img alt="example" style={{width: '100%'}} src={previewImage}/>
        </Modal>
    </>
}
export default SaleTankerWater;